<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useDisplay } from 'vuetify'
import { useStudentStore } from '@/stores/student'

const router = useRouter()

const studentStore = useStudentStore()
const { mdAndUp } = useDisplay()

const myDetails = () => {
  router.push({ name: 'settings' })
}
</script>

<template>
    <VCard @click="myDetails" class="dashboard-card dashboard-card--settings d-flex flex-column">
        <VCardTitle>
          <p class="dashboard-card__title d-flex flex-column d-md-block text-center text-md-left text-white">
            <span class="mr-md-4"><VIcon icon="mdi-cog" :size="mdAndUp ? 36 : 48" /></span>
            <span class="font-museo" :class="`font-${studentStore.fontStyle}`">{{ $t('pages.dashboard.settings.title')  }}</span>
          </p>
        </VCardTitle>
        <VCardText class="align-content-end text-white">
          <VRow>
            <VCol cols="12" md="7" class="d-none d-md-flex flex-column justify-space-between pt-0">
              <p class="dashboard-card__description pt-6 pb-3">
                {{ $t('pages.dashboard.settings.description') }}
              </p>
              <VBtn @click="myDetails" variant="tonal" rounded="xl" class="dashboard-card__view-btn dashboard-card__view-btn--settings">
                  {{ $t('pages.dashboard.settings.view_btn') }}
              </VBtn>
            </VCol>
            <VCol cols="12" md="5">
              <VImg class="dashboard-card__image" src="@images/dashboard/settings.svg" />
            </VCol>
          </VRow>
        </VCardText>
    </VCard>
</template>
